// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/deprecate-formik
import { FormikContextType } from 'formik'
import { FC } from 'react'

import {
  LogoAndTextFormValues,
  TextFormValues,
} from '../../../../../containers/EmbroideryService/types'
import { EmbroideryFont } from '../../../../../types/graphql'
import { FontSelector } from '../../selectors/FontSelector'
import { EmbroideryOptionWrapper } from '../../shared-form-styles'

interface Props {
  labelId: string
  form:
    | Pick<FormikContextType<TextFormValues>, 'touched' | 'errors' | 'values' | 'setFieldValue'>
    | Pick<
        FormikContextType<LogoAndTextFormValues>,
        'touched' | 'errors' | 'values' | 'setFieldValue'
      >
  textFonts: EmbroideryFont[] | null
}
export const Font: FC<Props> = ({ form, textFonts, labelId }) => {
  const handleSelectFont = (font: EmbroideryFont) => form.setFieldValue('font', font)

  if (!textFonts) return null
  return (
    <EmbroideryOptionWrapper>
      <FontSelector
        errorMessage={form.touched.font ? form.errors.font : undefined}
        labelId={labelId}
        onSelectFont={handleSelectFont}
        selectedFont={form.values.font?.name}
        fonts={textFonts}
      />
    </EmbroideryOptionWrapper>
  )
}
